import React from 'react'
import * as d3 from 'd3'
import './Chart.css'

import moment from 'moment'


const margin = { top: 40, right: 40, bottom: 40, left: 60 }


class Chart extends React.Component {
  componentDidMount = () => {
    this.setContext()
  }

  componentDidUpdate = () => {
    const { exerciseData, roundData } = this.props.data
    this.updateChart(exerciseData, roundData, this.props.width, this.props.height)
  }

  createChart = (containerWidth, containerHeight) => {
    const width = containerWidth - margin.left - margin.right,
      height = containerHeight - margin.top - margin.bottom

    const chart = d3.select(this.refs.chart)
            .attr('width', width + margin.left + margin.right)
            .attr('height', height + margin.top + margin.bottom)
            .append('g')
            .attr('transform', `translate(${margin.left},${margin.top})`)

    chart.append('g')
            .attr('id', 'lines')

    chart.append('g')
            .attr('id', 'roundData')

    chart.append('g')
            .attr('id', 'dots')

    chart.append('g')
            .attr('id', 'legends')

    chart.append('g')
            .attr('class', 'y-axis-left')

    chart.append('g')
            .attr('class', 'y-axis-right')
            .attr('transform', `translate(${width},0)`)

    chart.append('g')
            .attr('class', 'x-axis')
            .attr('transform', `translate(0,${height})`)

    chart.append('text')
      .attr('id', 'ylabel')
      .attr('transform', 'rotate(-90)')
      .attr('y', 0 - (margin.left))
      .attr('x', 0 - (height / 2))
      .attr('dy', '1em')
      .style('text-anchor', 'middle')
      .text('average time per rep')

    chart.append('text')
      .attr('id', 'xlabel')
      .attr('y', height + margin.bottom / 2)
      .attr('x', width / 2)
      .attr('dy', '1em')
      .style('text-anchor', 'middle')
      .text('time')

  }

  updateChart = (data, roundData, containerWidth, containerHeight) => {
    if (data === undefined) {
      return
    }

    const width = containerWidth - margin.left - margin.right,
      height = containerHeight - margin.top - margin.bottom

    const maxTime = d3.max([d3.max(data, d => d3.max(d.values, d => d.end)), 5])

    const scaleX = d3.scaleTime()
            .domain([0, maxTime])
            .range([0, width])

    const totalScaleY = d3.scaleLinear()
            .domain([0, d3.max(roundData, d => d.time)])
            .range([height, 0])

    const averageScaleY = d3.scaleLinear()
            .range([height, 0])

    averageScaleY.domain([0, d3.max(data, d => (d3.max(d.values, d => ((d.end - d.start) / d.reps))))])

    const svg = d3.select(this.refs.chart)

    svg.select('#xlabel')
      .transition()
      .attr('y', height + margin.bottom / 2)
      .attr('x', width / 2)

    svg.select('#ylabel')
      .transition()
      .attr('y', 0 - (margin.left))
      .attr('x', 0 - (height / 2))

    svg.select('.y-axis-left')
            .transition()
            .call(d3.axisLeft(averageScaleY))

    svg.select('.y-axis-right')
            .transition()
            .call(d3.axisRight(totalScaleY))

    svg.select('.x-axis')
            .transition()
            .call(d3.axisBottom(scaleX).tickFormat(d3.timeFormat('%M:%S')))



    const bargroups = svg
      .select('#lines')
      .selectAll('g')
      .data(data, name)

    bargroups.enter()
      .append('g')
      .attr('name', d => d.name)
      .attr('fill', d => d.color)

    bargroups.exit().remove()

    const bars = bargroups
      .selectAll('rect')
      .data(d => d.values, (d, index) => index)

    bars
      .enter()
      .append('rect')
        .attr('class', 'bar')
        .attr('x', d => scaleX(d.start) + 10)
        .attr('width', d => scaleX(d.end - d.start) - 5)
        .attr('y', d => averageScaleY((d.end - d.start) / d.reps))
        .attr('height', d => height - averageScaleY((d.end - d.start) / d.reps))

    bars
      .transition()
        .attr('x', d => scaleX(d.start) + 10)
        .attr('width', d => scaleX(d.end - d.start) - 5)
        .attr('y', d => averageScaleY((d.end - d.start) / d.reps))
        .attr('height', d => height - averageScaleY((d.end - d.start) / d.reps))

    bars.exit().remove()

    const barlabels = bargroups
      .selectAll('text')
      .data(d => d.values, (d, index) => index)

    barlabels
      .enter()
      .append('text')
        .attr('x', d => scaleX(moment(d.start) + moment((moment(d.end).diff(moment(d.start)) / 2))))
        .attr('y', height - 20)
        .attr('dy', '.35em')
        .attr('text-anchor', 'start')
        .style('fill', 'black')
        .text(d => d.reps)

    barlabels
      .transition()
      .attr('x', d => scaleX(moment(d.start) + moment((moment(d.end).diff(moment(d.start)) / 2))))
      .attr('y', height - 20)
      .text(d => d.reps)

    barlabels.exit().remove()


    const translateFirst = (d, i) => (
                `translate(${width},${20 * (i + 1)})`
            )

    const legend = svg
            .select('#legends')
            .selectAll('text')
            .data(data, name)

    legend.enter()
            .append('text')
            .attr('transform', translateFirst)
            .attr('dy', '.35em')
            .attr('text-anchor', 'end')
            .style('fill', d => d.color)
            .text(d => d.name)
            .merge(legend)
            .transition()
            .attr('transform', translateFirst)
  }

  setContext = () => {
    const { data, width, height } = this.props
    const { exerciseData, roundData } = data
    this.createChart(width, height)
    this.updateChart(exerciseData, roundData, width, height)
  }


  render() {
    return (
      <svg ref="chart" style={{ border: '1px solid black' }} />
    )
  }
}

export default Chart



// WEBPACK FOOTER //
// ./src/chart.js